import { useMutation } from "@tanstack/react-query";
import { useNavigate } from "react-router";
import { ApiError } from "@altek/ui/lib/problem";
import { toast } from "@altek/ui/lib/utils/toast";
import { useAuth } from "@/app/providers/AuthProvider";
import { sessionApi } from "@/features/auth/api/session.api";
import { toastFailure } from "@/lib/api/failure-toast";
import { forgetPushOnSignOut } from "@/lib/push/push-client";
import { forgetChatDrafts } from "@/features/chat/lib/chat-draft-store";

/** Başarılı çıkıştan sonra giriş ekranının üstünde görünen not. */
export const SIGNED_OUT_TITLE = "Çıkış yaptınız";
export const SIGNED_OUT_DETAIL = "Bu tarayıcıdaki oturumunuz kapatıldı.";

/**
 * «ÇIKIŞ YAP» — kabuğun TEK çıkış yolu: rayın alt bandı, profil menüsü ve engelleyen müşteri
 * seçicisi aynı mutasyonu kullanıyor (9 Ekim 2026, 5. tur; önce `AppLayout`'un içindeydi).
 *
 * Çıkışta bu tarayıcının arka plan bildirimi de susuyor (K6): paylaşılan bir bilgisayarda çıkan
 * kişinin mesajları, kalan kişinin ekranında «Yeni mesajınız var» diye çalmamalı. Önce abonelik —
 * hiç atmıyor; sunucu oturumu zaten kapatacak.
 *
 * ÇIKIŞ SESSİZ DEĞİL (9 Ekim 2026, 5. tur — giriş ekranı taramasından). Başarılı çıkıştan sonra
 * giriş ekranı hiçbir şey söylemeden açılıyordu; paylaşılan bilgisayardaki kişi oturumun gerçekten
 * kapandığından emin olamıyordu. Bildirim yuvası yönlendiricinin KARDEŞİ (`AppProviders`), yani
 * giriş ekranına geçişten sonra da görünüyor.
 *
 * BAŞARISIZ ÇIKIŞ, BAŞARILI GİBİ GÖRÜNMEMELİ (6 Ekim 2026, arayüz turu). Oturum çerezi HttpOnly,
 * tarayıcıdan silinemiyor: sunucu çıkışı reddettiyse oturum açık kalıyor ve sayfa yenilenince kişi
 * yine içeride. Bu yüzden:
 * - 401: oturum zaten bitmiş — temizle, giriş formuna git (çıkmış olmak istenen sonuç);
 * - başka her hata: kişi sayfada kalır ve neyin olmadığı söylenir; tekrar deneyebilir. «Destek
 *   kodu» yalnız sunucu arızasında (`toastFailure`). Ağ hatasında açıklama «Sunucuya ulaşılamadı.
 *   Bağlantınızı kontrol edin.» (`client.ts`, 8 Ekim 2026).
 */
export function useSignOut() {
  const { reset } = useAuth();
  const navigate = useNavigate();

  const leave = async () => {
    // sohbet-duzeltme 20 Ekim 2026 (H10): yarım sohbet taslakları bu sekmenin deposunda duruyor —
    // kişisel içerik, çıkışla birlikte siliniyor.
    forgetChatDrafts();
    await reset();
    await navigate("/login", { replace: true });
    toast.success(SIGNED_OUT_TITLE, SIGNED_OUT_DETAIL);
  };

  return useMutation({
    mutationFn: async () => {
      await forgetPushOnSignOut();
      return sessionApi.logout();
    },
    onSuccess: leave,
    onError: async (error) => {
      if (error instanceof ApiError && error.status === 401) {
        await leave();
        return;
      }
      toastFailure(error, "Çıkış yapılamadı");
    },
  });
}
